import sdks, { EVENTS } from '@/utils/_sasdk'
import cookie from 'js-cookie'

// 注册公共属性
sdks.registerPage({
  object_version: 'v1.0.0',
  business: 'VIPKIDmath',
  object: 'MathGrowth',
  app_id: '703dc5d1afbb9d76',
  student_id: cookie.get('mbstudentid') || '',
  parent_id: cookie.get('mbparentid') || ''
})

const sasdk = Object.assign({
  viewindex () {
    this.track(EVENTS.page, {
      event_id: 'Math_Diploma_WechatAdd_H5_View',
      str1: '用户访问H5页面'
    })
  }
}, sdks)

export default sasdk
